import requestHomesMapper from './homes/requestHomesMapper';
import requestCarsMapper from './cars/requestCarsMapper';
import requestProductsMapper from './products/requestProductsMapper';
import requestJobsMapper from './jobs/requestJobsMapper';

const verticalsMappers = {
  homes: requestHomesMapper,
  cars: requestCarsMapper,
  products: requestProductsMapper,
  jobs: requestJobsMapper,
};

export default function map(vertical, requestData, shouldResetWhere) {
  return verticalsMappers[vertical](requestData, shouldResetWhere);
}



// WEBPACK FOOTER //
// ./app/Serp/mappers/apiSearchRequest/requestMapper.js